import React, { useCallback } from "react";

import {
  useDeviceTesterDispatchContext,
  useDeviceTesterStateContext,
} from "../../../../device-tester-context-provider/DeviceTesterContextProvider";
import { DeviceTesterActionType } from "../../../../device-tester-context-provider/Reducer.types";
import { deviceToDialogName } from "../../../results-device-status-dialog-box/DeviceStatusDialogBox.types";

import { MobileDeviceStatusDialogButton } from "./MobileDeviceStatusDialogButton";
import { ConnectedMobileDeviceStatusDialogButtonProps } from "./MobileDeviceStatusDialogButton.types";

export const ConnectedMobileDeviceStatusDialogButton: React.FC<ConnectedMobileDeviceStatusDialogButtonProps> =
  ({ status, deviceName }) => {
    const { deviceTesterDispatch } = useDeviceTesterDispatchContext();
    const { deviceTesterState } = useDeviceTesterStateContext();

    const openDeviceDialog = useCallback(() => {
      deviceTesterDispatch({
        type: DeviceTesterActionType.SET_DEVICE_STATUS_DIALOG_STATE,
        deviceStatusDialogState: deviceToDialogName[deviceName],
      });
    }, [deviceTesterDispatch, deviceName]);

    return (
      <MobileDeviceStatusDialogButton
        status={status}
        deviceName={deviceName}
        isInfoFetched={deviceTesterState.isInfoFetched}
        openDeviceDialog={openDeviceDialog}
      />
    );
  };
